import CollectionList from '@/js/Shared/Collections/CollectionList';
import ContactItem    from '../Entities/ContactItem';

export { ContactsCollection as default };

/**
* Contacts Collection List
*
* @author      rsimoes <ruben-r-simoes@telecom.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
*/
class ContactsCollection extends CollectionList {
  /**
   * Constructor
   *
   * @public
   *
   * @since 7.0.0
   *
   * @return {void}
   */
  constructor() {
    super('id');
  }

  /**
   * Returns a contact from the index,
   * or a new ContactEnttity if index doesn't exist
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {string} id contact id
   *
   * @return {ContactItem}
   */
  get(id) {
    return (!this.index[id]) ? new ContactItem() : this.index[id];
  }

  /**
   * Resorts contacts items alphabeticly
   *
   * @public
   *
   * @since 7.0.0
   *
   * @return {void}
   */
  resortItems() {
    this.items.sort((a,b) => {
      return a.name.localeCompare(b.name, undefined, { numeric: true });
    })
  }
}